"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertBox = void 0;
const mithril_1 = __importDefault(require("mithril"));
const alertBox = (options) => {
    return (0, mithril_1.default)("div", { class: `notification is-${options.level}` }, (options.onclose ?
        (0, mithril_1.default)("button", {
            class: "delete",
            onclick: (() => { if (options.onclose)
                options.onclose(); }),
        }) : undefined), options.content);
};
exports.alertBox = alertBox;
